package games.polyclub.website.frontend.store.hooks

import games.polyclub.frontend.lib.react.ga4.GA4
import games.polyclub.frontend.lib.react.ga4.UaEventOptions
import js.core.Object
import js.core.jso

fun logEvent(params: Any? = null, eventBuilder: UaEventOptions.() -> Unit) {
    val data = jso(eventBuilder)
    GA4.send(jso {
        if (params != null) {
            Object.assign(this, params)
        }

        hitType = "event"
        eventCategory = data.category
        eventAction = data.action
        data.label?.let {
            eventLabel = it
        }
        data.value?.let {
            eventValue = it
        }
        data.nonInteraction?.let {
            nonInteraction = it
        }
        data.transport?.let {
            transport = it
        }
    })
}

/**
 * @param action Required. A description of the behaviour. E.g. 'Clicked Delete', 'Added a component', 'Deleted account', etc.
 * @param category Required. A top level category for these events. E.g. 'User', 'Navigation', 'App Editing', etc.
 * @param label Optional. More precise labelling of the related action. E.g. alongside the 'Added a component' action, we could add the name of a component as the label. E.g. 'Survey', 'Heading', 'Button', etc.
 * @param value Optional. A means of recording a numerical value against an event. E.g. a rating, a score, etc.
 * @param nonInteraction  Optional. If an event is not triggered by a user interaction, but instead by our code (e.g. on page load), it should be flagged as a nonInteraction event to avoid skewing bounce rate data.
 * @param transport Optional. This specifies the transport mechanism with which hits will be sent. Valid values include 'beacon', 'xhr', or 'image'.
 */
fun logEvent(
    action: String,
    category: String,
    label: String? = null,
    value: Int? = null,
    nonInteraction: Boolean? = null,
    transport: String? = null,
    params: Any? = null,
) {
    logEvent(params) {
        this.action = action
        this.category = category
        this.label = label
        this.value = value
        this.nonInteraction = nonInteraction
        this.transport = transport
    }
}
